<template lang="pug">
  .position-relative
    button.ml-auto.btn-goq-apps.icon-apps(
      type="button",
      @click="toggleApps"
    )
      span.d-none Apps
    //- clickしてGoQアプリ一覧が表示されたらtooltipを隠す
    span.text-nowrap.btn-goq-apps__tooltip(v-if="!flag")
      | GoQ Apps
</template>

<script>
export default {
  name: 'AppsButton',
  computed: {
    flag () {
      return this.$store.state.showApps
    }
  },
  methods: {
    toggleApps (e) {
      // アプリ一覧へ伝達するためにstoreのflag切り替え
      this.$store.dispatch('updateShowApps', { flag: !this.flag })
    }
  }
}
</script>
